import { Button } from "primereact/button";

const Botonera = ({ 
    rowData, 
    onEliminar,
    onZona, 
    onEditar,
}) => {
    const isAdmin = sessionStorage.getItem("authority") === "ROLE_ADMINISTRADOR";

    if (!isAdmin) {
        return null;
    }

    return ( 
        <div className="flex flex-column gap-2">
            <div className="flex gap-2 justify-content-start">
                {onEliminar && (<Button icon="pi pi-trash" className="p-button-rounded p-button-info  p-button-sm" tooltip="Eliminar"tooltipOptions={{ position: 'top' }} aria-label="Eliminar" onClick={() => onEliminar(rowData)}/>)}
                {onEditar && <Button tooltip="Editar" tooltipOptions={{ position: 'top' }} icon="pi pi-pencil" className="p-button-rounded p-button-info  p-button-sm" aria-label="Editar" onClick={() => onEditar(rowData)}/>}
                {onZona && <Button tooltip="Zona" tooltipOptions={{ position: 'top' }} icon="pi pi-check" className="p-button-rounded p-button-info  p-button-sm" aria-label="Zona" onClick={() => onZona(rowData)}/>}
            </div>
        </div>
        
    );
};

export default Botonera;
